import { render } from "./Index.vue?vue&type=template&id=823d3b2e&scoped=true&bindings={\"specialistData\":\"props\",\"userData\":\"props\",\"state\":\"setup\",\"data\":\"setup\",\"notEnterdData\":\"setup\",\"updateData\":\"setup\",\"updateFlow\":\"setup\",\"updateLandingState\":\"setup\",\"updateErrorDefaultInputData\":\"setup\",\"errors\":\"setup\",\"catchError\":\"setup\"}"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=823d3b2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-823d3b2e"

export default script